import React from 'react';
import { motion } from 'framer-motion';
import { FaBullhorn, FaMoneyBillWave, FaUsers, FaLeaf, FaPhone } from 'react-icons/fa';
const announcements = [
  {
    icon: <FaMoneyBillWave />,
    title: 'कर भरणा सूचना',
    date: 'मार्च २०२५',
    desc: 'सर्व नागरिकांना विनंती आहे की ग्रामपंचायत कर वेळेवर भरावा. थकबाकी असल्यास कार्यालयाशी संपर्क साधा.',
    color: '#138808'
  },
  {
    icon: <FaUsers />,
    title: 'ग्रामसभा सूचना',
    date: 'एप्रिल २०२५',
    desc: 'ग्रामसभेची बैठक लवकरच होणार आहे. सर्व ग्रामस्थांनी उपस्थित राहावे. वेळ व ठिकाण कार्यालयात जाहीर केले जाईल.',
    color: '#1565c0'
  },
  {
    icon: <FaLeaf />,
    title: 'नवीन योजना',
    date: 'मार्च २०२५',
    desc: 'ग्रामपंचायत नाशेरा येथे नवीन विकास कामे सुरू आहेत. अधिक माहितीसाठी कार्यालयाशी संपर्क साधा.',
    color: '#6a1b9a'
  },
];

function Announcements() {
  return (
    <div style={{ marginTop: '80px' }}>
      {/* Hero */}
      <motion.section
        className="hero"
        style={{ height: '50vh' }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        <div className="hero-content">
          <h1 className="page-hero-title">घोषणा</h1>
          <p className="page-hero-sub">ग्रामपंचायत नाशेराच्या अधिकृत सूचना व घोषणा</p>
        </div>
      </motion.section>

      {/* Announcements Cards */}
      <section className="services-section" style={{ background: '#f8f9fa' }}>
        <div className="container">
          <h2 className="section-title">अलीकडील घोषणा</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem', marginBottom: '3rem' }}>
            {announcements.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                style={{
                  background: 'white',
                  padding: '1.5rem',
                  borderRadius: '12px',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                  borderLeft: '4px solid #138808',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem'
                }}
                whileHover={{ y: -4, boxShadow: '0 8px 25px rgba(0,0,0,0.13)' }}
              >
                <div style={{
                  width: '52px', height: '52px',
                  background: 'rgba(19,136,8,0.1)',
                  borderRadius: '50%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '1.4rem', color: '#138808', flexShrink: 0
                }}>
                  {item.icon}
                </div>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '4px' }}>
                    <h3 style={{ color: '#2c3e50', fontSize: '1.05rem', fontWeight: '700', margin: 0 }}>{item.title}</h3>
                    <span style={{ fontSize: '0.78rem', color: '#138808', background: 'rgba(19,136,8,0.1)', padding: '2px 8px', borderRadius: '20px', fontWeight: '600', whiteSpace: 'nowrap' }}>{item.date}</span>
                  </div>
                  <p style={{ color: '#666', fontSize: '0.92rem', lineHeight: 1.7, margin: 0 }}>{item.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Contact note */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            style={{
              background: 'white',
              padding: '1.5rem',
              borderRadius: '12px',
              boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
              borderLeft: '4px solid #138808',
              display: 'flex',
              alignItems: 'center',
              gap: '1rem',
              maxWidth: '500px',
              margin: '0 auto'
            }}
          >
            <div style={{ width: '52px', height: '52px', background: 'rgba(19,136,8,0.1)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.4rem', color: '#138808', flexShrink: 0 }}>
              <FaPhone />
            </div>
            <div>
              <h4 style={{ color: '#2c3e50', fontWeight: '700', marginBottom: '3px' }}>अधिक माहितीसाठी संपर्क करा</h4>
              <p style={{ color: '#138808', fontWeight: '600', margin: 0 }}>+91 7620 135 257</p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}

export default Announcements;
